import { NodeModel } from "../_model/NodeModel";
import { DecorationCellFactory } from "../cellFactory/decorationCellFactory";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class CellFactory extends NodeModel {
    constructor() {
        super("CellFactory");

        this.type = new Types().CellFactory;

        this.x = 0;
        this.y = 0;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 200;
        this.width = 200;
        this.tx = 0;
        this.Xw = 0;
        this.operationSelected = '';
        this.srcImg = require("@/assets/Fluxogramas/citrus_fabrica_de_celulas.png");
        this.data = [new Properties({...this })];

        this.decorate = async function(callback) {
            this.decorator = new DecorationCellFactory();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new CellFactory()

            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.readOnly = this.readOnly
            cloned.expressionVisible = this.expressionVisible
            cloned.decorator = null
            cloned.data = this.data.map(d => d.clone());

            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.data = node.data.map(d => new Properties({...d }));
        }

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs;
            }
            this.expressionVisible = node.expressionVisible;
        }
    }
}

export { CellFactory };